import api from './api';
import { toast } from 'react-toastify';

export function initOfflineHandler() {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const isMutation = error.config && !['get', 'GET'].includes(error.config.method);
      
      if (error.isOffline && isMutation) {
        toast.error(error.userMessage || 'Server temporarily unavailable. Please retry.', {
          position: "bottom-right",
          autoClose: 5000,
          icon: '☕',
          style: { background: '#f59e0b', color: 'white' }
        });
      }
      
      return Promise.reject(error);
    }
  );
}